
import React, {  Children, cloneElement  } from 'react';
import './index.less'
import Header from '../Header';
import Footer from '../Footer';
export default function PageBox(props) {
  return (
    <div className="pagebox">
      <Header  />
      <div className='pages'>
        {
          Children.map(props.children, (child, index) =>{
            return cloneElement( child, {
              key: index,
            });
          })
        }
      </div>
      <Footer />
    </div>
  );
}
